/* =============================================================================
 * "संपर्क" content — hard-coded on purpose.
 *
 * This changes maybe once a season, so an API endpoint + admin editor would be
 * more moving parts than it's worth. Edit this file and redeploy (a static
 * rebuild takes seconds). Anything marked TODO is placeholder text.
 * ========================================================================== */

import { MAIN_SITE_URL } from "@shared/config.ts";

export const ABOUT = {
  heading: "छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे",
  paragraphs: [] as string[],
  mainSite: MAIN_SITE_URL,
};

/**
 * Phone `number`s are stored as plain ASCII digits (not Devanagari) — they're
 * used verbatim in `tel:` links, which need real digits to be dialable.
 * About.tsx displays them through `toDeva()` so they still show as Devanagari,
 * matching the rest of the site.
 */
export const CONTACT = {
  address:
    "छत्रपती सेवा प्रतिष्ठान\n१०८८, मनोरमा\nदुसरा मजला, जनता बँकेसमोर,\nबाजीराव रास्ता, शनिपार चौक,\nसदाशिव पेठ, पुणे ४११०३०",
  phones: [
    { label: "मुंबई विभाग – श्री केतन म्हात्रे", number: "79001 11562" },
    { label: "पुणे विभाग – श्री मंगेश बरबडे", number: "99212 37999" },
    { label: "नाशिक विभाग – श्री मोहन बरबडे", number: "88885 63394" },
    {
      label: "छत्रपती संभाजी नगर विभाग – श्री मनोज तळणीकर",
      number: "94229 96290",
    },
    { label: "अमरावती विभाग – श्री शंकरराव गायकवाड", number: "96043 02859" },
    { label: "नागपूर विभाग – सौ धनश्री कारकर", number: "98231 83016" },
  ] as { label: string; number: string }[],
  email: "mangeshbarbade11@gmail.com" as string | null,
  hours: null as string | null,
  contactPage: `${MAIN_SITE_URL}contact/`,
};

export const FAQ: { q: string; a: string }[] = [];
